// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (-webkit-min-device-pixel-ratio:0){input[data-v-f79096ee],select[data-v-f79096ee],textarea[data-v-f79096ee]{font-size:16px}}.ps-progress span[data-v-f79096ee]{background-color:#fb9013;border-radius:4px;height:18px;left:0;position:absolute}.rating[data-v-f79096ee]{align-items:center;display:flex}.product[data-v-f79096ee]{margin-bottom:1px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
